import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Select,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, api, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import Country from "../../../../Pages/Masters/Roles and Permissions/Country.json";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI201_4 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [deleteDilog, setDeleteDialog] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    finalcalAssistanceCurrency: "",
    finalcalAssistance: {
      reliefCredits: "",
      subsidies: "",
      holidays: "",
      incentives: "",
      ecas: "",
      investmentgrant: "",
      other: "",
      total: "",
    },
    // b
    CountrywisefinalcalAssistance: [
      {
        country: "",
        currency: "",
        reliefCredits: "",
        subsidies: "",
        holidays: "",
        incentives: "",
        ecas: "",
        investmentgrant: "",
        other: "",
      },
    ],
    shareholdingstructure: {
      action: "Yes" === "Yes" ? true : false,
      remark: "",
    },
  });
  const [selectedValue, setSelectedValue] = useState("Yes");
  const [countryData, setCountryData] = useState([
    {
      country: "",
      currency: "",
      reliefCredits: "",
      subsidies: "",
      holidays: "",
      incentives: "",
      ecas: "",
      investmentgrant: "",
      other: "",
    },
  ]);
  const [griReview, setGriReview] = React.useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(true);

  React.useEffect(() => {
    const handleStorage = () =>
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const validateForm = () => {
    let newErrors = {};

    // const validateFields = (obj, path = "") => {
    //   Object.keys(obj).forEach((key) => {
    //     const currentPath = path ? `${path}.${key}` : key;

    //     if (typeof obj[key] === "object" && obj[key] !== null) {
    //       validateFields(obj[key], currentPath);
    //     } else {
    //       if (!obj[key]) {
    //         newErrors[currentPath] = "This field is required";
    //       }
    //     }
    //   });
    // };

    // Run validation for all general fields
    // validateFields(formData);

    // Function to check if any amount field is filled but currency is empty
    const validateAmountCurrencyPair = (
      amountFields,
      currency,
      currencyKey
    ) => {
      const isAnyFieldFilled = Object.values(amountFields).some((val) => val);
      console.log(isAnyFieldFilled, currency, "data for currency");
      if (isAnyFieldFilled && (currency === "" || currency === undefined)) {
        newErrors[currencyKey] = "Please select a currency";
      }
    };

    // Validate `finalcalAssistance`
    validateAmountCurrencyPair(
      formData.finalcalAssistance,
      formData.finalcalAssistanceCurrency,
      "finalcalAssistanceCurrency"
    );

    // Validate `CountrywisefinalcalAssistance`
    console.log(countryData, "formData.CountrywisefinalcalAssistance");
    countryData.forEach((entry, index) => {
      const isAnyFieldFilled = Object.keys(entry)
        .filter((key) => key !== "country" && key !== "currency")
        .some((key) => entry[key].trim() !== "");

      if (isAnyFieldFilled && !entry.currency.trim()) {
        newErrors[`CountrywisefinalcalAssistance.${index}.currency`] =
          "Please select a currency";
      }

      if (isAnyFieldFilled && !entry.country.trim()) {
        newErrors[`CountrywisefinalcalAssistance.${index}.country`] =
          "Please select a country";
      }
    });

    // Validate `shareholdingstructure`
    if (
      formData.shareholdingstructure.action &&
      formData.shareholdingstructure.remark === ""
    ) {
      newErrors["shareholdingstructure.remark"] =
        "Remark is required if action is 'Yes'";
    }

    setErrors(newErrors);
    console.log(newErrors, "Validation Errors");

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleRadioChange = (event) => {
    const { name, value } = event.target;
    setSelectedValue(name === "shareholdingstructure" && value);

    setFormData((prev) => ({
      ...prev,
      shareholdingstructure: {
        ...prev.shareholdingstructure,
        action: value === "Yes" ? true : false,
        remark: value === "No" ? "" : prev.shareholdingstructure?.remark || "",
      },
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      shareholdingstructure: {
        ...prev.shareholdingstructure,
        remark: value,
      },
    }));
  };

  const handleAddCountry = () => {
    setCountryData((prev) => [
      ...prev,
      {
        country: "",
        currency: "",
        reliefCredits: "",
        subsidies: "",
        holidays: "",
        incentives: "",
        ecas: "",
        investmentgrant: "",
        other: "",
      }, // Add new object
    ]);
    setIsAddButtonDisabled(true);
  };

  const handleDeleteCountry = (index) => {
    setDeleteDialog(false);
    setCountryData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleTableChange = (e) => {
    const { name, value } = e.target;
    const [main, sub] = name.split(".");
    const numericValue = Number(value) || 0; // Ensure value is treated as a number

    setFormData((prev) => {
      const prevValue = Number(prev[main]?.[sub]) || 0; // Get the previous value of the field
      const prevTotal = Number(prev[main]?.total) || 0; // Get the previous total

      return {
        ...prev,
        [main]: {
          ...prev[main],
          [sub]: numericValue,
          total: prevTotal - prevValue + numericValue, // Adjust total using previous field value
        },
      };
    });
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GRI200&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear : false)
          setDisabled(true);
        const response = res.data.data.GRI200;
        setFormData({
          finalcalAssistanceCurrency: response?.finalcalAssistanceCurrency,
          finalcalAssistance: {
            reliefCredits: response?.finalcalAssistance?.reliefCredits,
            subsidies: response?.finalcalAssistance?.subsidies,
            holidays: response?.finalcalAssistance?.holidays,
            incentives: response?.finalcalAssistance?.incentives,
            ecas: response?.finalcalAssistance?.ecas,
            investmentgrant: response?.finalcalAssistance?.investmentgrant,
            other: response?.finalcalAssistance?.other,
            total: response?.finalcalAssistance?.total,
          },

          shareholdingstructure: {
            action:
              response?.shareholdingstructure?.action === true ? "Yes" : "No",
            remark: response?.shareholdingstructure?.remark,
          },
        });
        setCountryData(
          response?.CountrywisefinalcalAssistance.length > 0
            ? response?.CountrywisefinalcalAssistance?.map((item) => {
                return {
                  country: item?.country,
                  currency: item?.currency,
                  reliefCredits: item?.reliefCredits,
                  subsidies: item?.subsidies,
                  holidays: item?.holidays,
                  incentives: item?.incentives,
                  ecas: item?.ecas,
                  investmentgrant: item?.investmentgrant,
                  other: item?.other,
                };
              })
            : [
                {
                  country: "",
                  currency: "",
                  reliefCredits: "",
                  subsidies: "",
                  holidays: "",
                  incentives: "",
                  ecas: "",
                  investmentgrant: "",
                  other: "",
                },
              ]
        );
      })
      .catch((err) => console.log(err, "error for get responssse"));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const inputData = [{ fields: [{ title: "Amount" }] }];

  const defaultSegments = {
    percentage: [
      {
        title: "Tax relief and tax credits",
        field: "finalcalAssistance.reliefCredits",
      },
      { title: "Subsidies", field: "finalcalAssistance.subsidies" },
      { title: "Royalty Holidays", field: "finalcalAssistance.holidays" },
      { title: "Financial incentives", field: "finalcalAssistance.incentives" },
      {
        title: "Financial assistance from Export Credit Agencies (ECAs);",
        field: "finalcalAssistance.ecas",
      },
      {
        title:
          "Investment grants, research and development grants, and other relevant types of grant",
        field: "finalcalAssistance.investmentgrant",
      },
      {
        title:
          "Other financial benefits received or receivable from any government for any operation.",
        field: "finalcalAssistance.other",
      },
      {
        title: "Total Financial Assistance Received",
        field: "finalcalAssistance.total",
      },
    ],
    rendervalue: [
      { title: "Tax relief and tax credits", field: "reliefCredits" },
      { title: "Subsidies", field: "subsidies" },
      { title: "Royalty Holidays", field: "holidays" },
      { title: "Financial incentives", field: "incentives" },
      {
        title: "Financial assistance from Export Credit Agencies (ECAs);",
        field: "ecas",
      },
      {
        title:
          "Investment grants, research and development grants, and other relevant types of grant",
        field: "investmentgrant",
      },
      {
        title:
          "Other financial benefits received or receivable from any government for any operation.",
        field: "other",
      },
    ],
  };

  const DropDownData = {
    finalcalAssistanceCurrency: [
      {
        currency: ["USD", "EUR", "INR"],
        currencyFieldName: "finalcalAssistanceCurrency",
      },
    ],
    CountrywisefinalcalAssistance: [
      {
        currency: ["USD", "EUR", "INR"],
        currencyFieldName: "currency",
      },
    ],
  };

  const handleCurrencyChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleCurrencyChangeArray = (index, event) => {
    const { name, value } = event.target;
    const [main, sub] = name.split(".");

    setFormData((prev) => {
      const updatedData = [...prev.CountrywisefinalcalAssistance];
      updatedData[index] = {
        ...updatedData[index],
        [main]: {
          ...updatedData[index][main],
          [sub]: value,
        },
      };
      return { ...prev, CountrywisefinalcalAssistance: updatedData };
    });
  };

  const handleChangeTable = (e, index,type) => {
    const { name, value } = e.target;
    console.log(name, value, index, "handleChangeTable");
        if (type === "number" && !/^\d*\.?\d*$/.test(value)) {
      return; // 🚫 Block invalid input
    }
    setCountryData((prev) => {
      const newData = [...prev]; // Create a shallow copy of the array
      newData[index] = {
        ...newData[index], // Copy the object at the given index
        [name]: value, // Update the specific field dynamically
      };
      const lastRowFilled = Object.values(newData[newData.length - 1]).every(
        (val) => val?.toString().trim() !== ""
      );
      setIsAddButtonDisabled(!lastRowFilled);
  
      return newData;
    });
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return;
      const dataToSend = {
        ...formData,
        CountrywisefinalcalAssistance: [...countryData],
      };
      if (formData?.shareholdingstructure?.action === false) {
        delete dataToSend?.shareholdingstructure?.remark;
      }
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GRI200",
          ...dataToSend,
          submitted201_4: true,
        })
          .then((res) => {
            navigate(`/gri/economic-performance/202-1/${id}`);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/economic-performance/202-1/${id}`);
    }
  };

  const renderContent = (hide) => (
    <>
      {console.log("hideb", hide)}
      {!hide && (
        <p className={styles.section_heading}>201:Economic Performance</p>
      )}
      <p
        className={styles.main_heading}
        style={{
          textDecoration: "none",
          marginBottom: hide ? "-1rem" : "0rem",
        }}
      >
        201-4 : <span>Financial assistance received from government</span>
      </p>
      <p className={styles.ques_heading} style={{ display: "flex" }}>
        a. Total monetary value of financial assistance received by the
        organization from any
        <br />
        government during the reporting period, including:
      </p>
      <p
        className={styles.ques_heading}
        style={{
          marginLeft: "20px",
          margin: hide ? "-1rem 1rem" : "1rem 1rem",
        }}
      >
        Currency:
        <span>
          {DropDownData?.finalcalAssistanceCurrency.map((section) => {
            console.log(section, "currency");
            return (
              <Select
                name={section.currencyFieldName}
                value={formData?.[section.currencyFieldName] || ""}
                placeholder="Select"
                onChange={handleCurrencyChange}
                displayEmpty
                size="small"
                disabled={disabled}
                sx={{ padding: "0px 10px", marginLeft: "10px", width: "12%" }}
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                {section?.currency?.map((currencyOption) => (
                  <MenuItem key={currencyOption} value={currencyOption}>
                    {currencyOption}
                  </MenuItem>
                ))}
              </Select>
            );
            // {errors?<FormHelperText>
            //     {errors?.[section.currencyFieldName]}
            //     </FormHelperText>:null
            //   }
          })}
        </span>
      </p>
      <Typography
        variant="body2"
        color="error"
        // key={`${rowIdx}-${field}-${idx}`}
        style={{
          lineHeight: "1.2",
          margin: hide ? "-1rem 0rem" : "2px 50px",
          color: "#d34040",
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        {errors?.finalcalAssistanceCurrency}
      </Typography>
      {inputData?.map((section, tableIndex) => (
        <TableContainer
          key={tableIndex}
          component={Paper}
          sx={{
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            // mt: "2rem",
            borderRadius: "10px",
            ml: "20px",
            width: "97%",
          }}
        >
          <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
            <TableHead>
              <TableRow
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "#1C486B",
                  border: "1px solid #ddd",
                }}
              >
                <TableCell
                  sx={{
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    width: "15rem",
                  }}
                >
                  {"S. No."}
                </TableCell>
                <TableCell
                  sx={{
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    width: "35rem",
                  }}
                >
                  {"Categories"}
                </TableCell>
                {section.fields?.map((field, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      border: "1px solid #ddd",
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      width: "35rem",
                    }}
                  >
                    {field?.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {defaultSegments?.percentage?.map((segment, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell sx={{ width: "6%", textAlign: "center" }}>
                    {segment?.title?.includes("Total")
                      ? ""
                      : `${rowIndex + 1}.`}
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #DBDBDB",
                      py: "0.5rem",
                      width: segment?.width || "63%",
                      maxWidth: segment?.width || "100%",
                      background:
                        segment?.title === "Total Financial Assistance Received"
                          ? "#EFEFEF"
                          : "white",
                    }}
                  >
                    {segment?.title}
                  </TableCell>

                  {section?.fields?.map((field, index) => {
                    const [fieldName, name] = segment.field?.split(".") || [];
                    return (
                      <TableCell
                        key={index}
                        sx={{
                          border: "1px solid #DBDBDB",
                          py: "0.5rem",
                          width: field?.width || "63%",
                          maxWidth: field?.width || "100%",
                          background:
                            segment?.title ===
                            "Total Financial Assistance Received"
                              ? "#EFEFEF"
                              : "white",
                        }}
                      >
                        <Box sx={{ minWidth: "100px" }}>
                          <TextField
                            name={segment.field}
                            value={formData?.[fieldName]?.[name] || ""}
                            placeholder={
                              segment?.title ===
                              "Total Financial Assistance Received"
                                ? "0"
                                : "Enter Number"
                            }
                            type="text"
                            multiline
                            rows={1}
                            size="small"
                            variant="standard"
                            InputProps={{ disableUnderline: true }}
                            disabled={segment?.title === "Total" || disabled}
                            onChange={
                              segment?.title ===
                              "Total Financial Assistance Received"
                                ? undefined
                                : handleTableChange
                            }
                          />
                        </Box>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ))}
      <Typography
        variant="body2"
        color="error"
        // key={`${rowIdx}-${field}-${idx}`}
        style={{
          lineHeight: "1.2",
          margin: "2px 0",
          color: "#d34040",
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        {errors?.finalcalAssistance}
      </Typography>

      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <p className={styles.ques_heading} style={{ display: "flex" }}>
        b. Country wise, Total monetary value of financial assistance received
        by the organization from any government during the reporting period,
        including:
      </p>
      {console.log(countryData, "countryData")}
      {countryData.length > 0 &&
        countryData.map((data, countryindex) => (
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                margin: hide ? "-1.5rem 0rem" : "0rem",
                gap: "1.5rem",
                ml: "25px",
                width: "97%",
                marginBottom: "0rem",
              }}
            >
              <p
                className={styles.ques_heading}
                style={{ width: "22%", marginBottom: "0px",marginRight:"10px" }}
              >
                Country:
                <span>
                  <Select
                    name="country"
                    value={data?.["country"]}
                    placeholder="Select"
                    //  onChange={handleCurrencyChange}
                    onChange={(e) => handleChangeTable(e, countryindex,"text")}
                    displayEmpty
                    size="small"
                    sx={{
                      width: "63%",
                      // width: "60%", // Ensures it takes full width
                      // backgroundColor: "white", // Background color
                      borderRadius: "4px", // Rounded corners
                      "& .MuiSelect-select": {
                        padding: "10px 18px", // Adjust padding
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5", // Hover effect
                      },
                      padding: "0px 10px",
                      marginLeft: "10px",
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxWidth: 200,
                          maxHeight: 300, // Limit the height
                          overflowY: "auto", // Allow scrolling
                          // backgroundColor: "#ffffff", // Dropdown background color
                          borderRadius: "8px", // Rounded dropdown corners
                          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", // Add shadow effect
                        },
                      },
                    }}
                    disabled={disabled}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {Country.countries?.map((item) => (
                      <MenuItem
                        sx={{
                          whiteSpace: "normal", // Allow text wrapping
                          wordBreak: "break-word", // Break long words
                          maxWidth: "100%", // Ensure flexible width
                          fontSize: "14px", // Adjust font size
                          padding: "8px 12px", // Adjust padding
                          "&:hover": {
                            backgroundColor: "#e3f2fd", // Light blue hover effect
                          },
                        }}
                        key={item.name}
                        value={item.name}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <p>
                    {" "}
                    <Typography
                      variant="body2"
                      color="error"
                      // key={`${rowIdx}-${field}-${idx}`}
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 50px",
                        color: "#d34040",
                        fontSize: "12px",
                        fontWeight: 600,
                      }}
                    >
                      {
                        errors[
                          `CountrywisefinalcalAssistance.${countryindex}.country`
                        ]
                      }
                    </Typography>
                  </p>
                </span>
              </p>

              <p
                className={styles.ques_heading}
                style={{ width: "30%", marginBottom: "0px" }}
              >
                Currency:
                <span>
                  {DropDownData?.CountrywisefinalcalAssistance.map(
                    (section, index) => {
                      const [main, sub] = section.currencyFieldName.split(".");
                      return (
                        <Select
                          name={section.currencyFieldName}
                          value={data?.[section.currencyFieldName]}
                          placeholder="Select"
                          onChange={(e) => handleChangeTable(e, countryindex,"text")}
                          displayEmpty
                          size="small"
                          disabled={disabled}
                          sx={{
                            padding: "0px 10px",
                            width: "47%",
                            marginLeft: "10px",
                            "& .MuiSelect-select": {
                              padding: "10px 18px", // Adjust padding
                            },
                          }}
                        >
                          <MenuItem value="">
                            <em>Select</em>
                          </MenuItem>
                          {section?.currency?.map((currencyOption) => (
                            <MenuItem
                              key={currencyOption}
                              value={currencyOption}
                            >
                              {currencyOption}
                            </MenuItem>
                          ))}
                        </Select>
                      );
                      // {errors?<FormHelperText>
                      //     {errors?.[section.currencyFieldName]}
                      //     </FormHelperText>:null
                      //   }
                    }
                  )}
                  <Typography
                    variant="body2"
                    color="error"
                    // key={`${rowIdx}-${field}-${idx}`}
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 50px",
                      color: "#d34040",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}
                  >
                    {
                      errors[
                        `CountrywisefinalcalAssistance.${countryindex}.currency`
                      ]
                    }
                  </Typography>
                </span>
              </p>

              {countryData.length > 0 && (
                <Box sx={{textAlign: "right",
    width: "42%",
    marginTop: "2.5%"}}>
                <IconButton
                  // onClick={() => handleDeleteCountry(countryindex)}
                  onClick={() => setDeleteDialog(true)}
                  color="error"
                  disabled={disabled || countryData.length === 1} 
                >
                  <DeleteIcon />
                </IconButton>
                </Box>
              )}
            </Box>

            <Dialog open={deleteDilog} onClose={() => setDeleteDialog(false)}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDeleteDialog(false)} color="primary">
                  Cancel
                </Button>
                <Button
                  // onClick={handleDeleteAggree}
                  onClick={() => handleDeleteCountry(countryindex)}
                  color="secondary"
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>

            {inputData?.map((section, tableIndex) => (
              <TableContainer
                key={section.fieldName}
                component={Paper}
                sx={{
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  mt: "0rem",
                  borderRadius: "10px",
                  ml: "20px",
                  width: "97%",
                }}
              >
                <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                  <TableHead>
                    <TableRow
                      sx={{
                        borderRadius: "10px",
                        backgroundColor: "#1C486B",
                        border: "1px solid #ddd",
                      }}
                    >
                      <TableCell
                        sx={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: "10rem",
                        }}
                      >
                        {"S. No."}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: "40rem",
                        }}
                      >
                        {"Categories"}
                      </TableCell>
                      {section.fields?.map((field) => (
                        <TableCell
                          key={field.fieldName}
                          sx={{
                            border: "1px solid #ddd",
                            fontWeight: "bold",
                            color: "#FFFFFF",
                            width: "40rem",
                          }}
                        >
                          {field.title}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {defaultSegments?.rendervalue?.map((segment, rowIndex) => (
                      <TableRow key={rowIndex}>
                        {/* Handle SNo. properly for Total row */}
                        <TableCell sx={{ width: "6%", textAlign: "center" }}>
                          {segment?.title?.includes("Total")
                            ? ""
                            : `${rowIndex + 1}.`}
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #DBDBDB",
                            py: "0.5rem",
                            width: "63%",
                            maxWidth: "100%",
                            background: segment?.title?.includes("Total")
                              ? "#EFEFEF"
                              : "white",
                          }}
                        >
                          {segment.title}
                        </TableCell>

                        {section.fields?.map((field, index) => {
                          return (
                            <TableCell
                              key={index}
                              sx={{
                                border: "1px solid #DBDBDB",
                                py: "0.5rem",
                                width: "63%",
                                maxWidth: "100%",
                                background: "white",
                              }}
                            >
                              <Box sx={{ minWidth: "100px" }}>
                                <TextField
                                  sx={{ width: "100%" }}
                                  name={segment.field}
                                  value={data?.[segment?.field] || ""}
                                  placeholder={"Enter Number"}
                                  disabled={disabled}
                                  type="text"
                                  multiline
                                  rows={1}
                                  size="small"
                                  variant="standard"
                                  InputProps={{ disableUnderline: true }}
                                  // disabled={segment?.title === "Total"} // Prevent editing "Total" row
                                  onChange={(e) =>
                                    handleChangeTable(e, countryindex,"number")
                                  }
                                />
                              </Box>
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ))}
            {console.log(countryindex,countryData.length  ,"datata")}
            {/* {countryindex === countryData.length - 1 && ( */}
            {countryindex === countryData.length  ||
              (!hide && (
                <Box textAlign="right" sx={{ mr: "11px" }}>
                  <Button
                    // variant="contained"
                    disabled={disabled || isAddButtonDisabled}
                    onClick={handleAddCountry}
                    sx={{
                      mt: "1rem",
                      backgroundColor: "transparent",
                      border: "1px solid #1C486B",
                      color: "#1C486B",
                    }}
                  >
                    <AddIcon color="#1C486B" />
                    Add Another Country
                  </Button>
                </Box>
              ))}

            <Typography
              variant="body2"
              color="error"
              // key={`${rowIdx}-${field}-${idx}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              {
                // errors?.CountrywisefinalcalAssistance?.map((item, index) => (
                //   <div key={index}>
                //     <strong>Country Index:</strong> {item.index + 1} <br />
                //     <strong>Errors:</strong>{" "}
                //     {Object.keys(item.errors).map((field, idx, fieldsArray) => (
                //       <>
                //         <span key={field}>
                //           <strong>{field}:</strong> is required
                //           {idx < fieldsArray.length - 1 && ", "}
                //         </span>
                //       </>
                //     ))}
                //     <hr />
                //   </div>
                // ))
              }
              {errors?.CountrywisefinalcalAssistance?.map(
                (item, index) =>
                  countryindex === index && (
                    <Typography
                      key={index}
                      variant="body2"
                      color="error"
                      sx={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "12px",
                        fontWeight: 600,
                      }}
                    >
                      <strong>Errors:</strong>{" "}
                      {Object.keys(item.errors).map(
                        (field, idx, fieldsArray) => (
                          <>
                            <span key={field}>
                              <strong>
                                {field}
                                {index}:
                              </strong>{" "}
                              is required
                              {idx < fieldsArray.length - 1 && ", "}
                            </span>
                          </>
                        )
                      )}
                    </Typography>
                  )
              )}
            </Typography>
          </Box>
        ))}

      <p
        className={styles.ques_heading}
        style={{ display: "flex", marginBottom: hide ? "-1rem" : "0rem" }}
      >
        c. Whether, and the extent to which, any government is present in the
        shareholding structure
      </p>
      <Box sx={{ ml: 3 }}>
        <RadioGroup
          row
          name="shareholdingstructure"
          value={selectedValue}
          onChange={handleRadioChange}
          disabled={disabled}
        >
          <FormControlLabel
            value="Yes"
            control={<Radio disabled={disabled} />}
            label="Yes"
          />
          <FormControlLabel
            value="No"
            control={<Radio disabled={disabled} />}
            label="No"
          />
        </RadioGroup>
        {selectedValue === "Yes" && (
          <TextField
            name="shareholdingstructureDetails"
            placeholder="Enter Text"
            variant="outlined"
            size="small"
            multiline
            minRows={1}
            value={formData?.shareholdingstructure?.remark}
            onChange={handleInputChange}
            fullWidth
            sx={{ mt: 2 }}
            disabled={disabled}
          />
        )}
        <Typography
          variant="body2"
          color="error"
          // key={`${rowIdx}-${field}-${idx}`}
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            color: "#d34040",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {errors?.shareholdingstructure}
        </Typography>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent(hide)}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};
export default GRI201_4;
